import React from 'react';
import moment from 'moment';
import { useDateService } from '../../../utils/hooks/useDateService';
import useFieldHelper from '../fieldHelper';
import TextField from '../text/TextField';

export interface DurationBetweenTwoDatesFieldProps {
  dateFromSource?: Nullable<string>;
  dateToSource?: Nullable<string>;
  dateFromValue?: moment.MomentInput;
  dateToValue?: moment.MomentInput;
  label?: any;
  shortValue?: boolean;
  [p: string]: any;
}

const DurationBetweenTwoDatesField = ({
  dateFromSource,
  dateToSource,
  dateFromValue,
  dateToValue,
  shortValue,
  ...props
}: DurationBetweenTwoDatesFieldProps) => {
  const { getValue: getDateFromValue } = useFieldHelper({ source: dateFromSource, value: dateFromValue });
  const { getValue: getDateToValue } = useFieldHelper({ source: dateToSource, value: dateToValue });
  const { getStringDurationBetweenTwoDates } = useDateService();

  const dateFrom = getDateFromValue();
  const dateTo = getDateToValue();

  const resultValue = getStringDurationBetweenTwoDates(dateFrom, dateTo, shortValue);

  return <TextField {...props} value={resultValue} />;
};

export default DurationBetweenTwoDatesField;
